import SettingBase from '../settings/util/SettingBase'

class RoutesController extends SettingBase {
  /*@ngInject*/
  constructor($state) {
    super();
    this.acl = {}
    this.hasACL = {} 
    this.id = 'routes'
    this.$state = $state
    this.hasACL = {}
  }
  $onInit() {
    super.$onInit()
    for (let key in this.acl['setting-routes']) {
      this.hasACL[this.acl['setting-routes'][key]] = true;
    }
  }
}
export default RoutesController;


// WEBPACK FOOTER //
// ./client/app/components/routes/routes.controller.js